exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6378bb7b]:export{menu-bgc-oragne:#F2C46D}.lang-select[data-v-6378bb7b]{font-size:16px !important;display:inline-block}.lang-select span[data-v-6378bb7b]{cursor:pointer}.lang-select span.active[data-v-6378bb7b]{opacity:0.7}.lang-select span[data-v-6378bb7b]:hover{color:#85BAE5}\n", ""]);

// exports
